/* =========================================================
   Evergreen – Quiz (sections/ev-quiz.liquid + ev-quiz-branch.liquid)
   - Lit les données JSON des sections « ramură » de la page.
   - Écrans : start → nevoie → întrebări → rezultat (un écran à la fois).
   - Résultat : celui dont toutes les conditions sont choisies, le plus précis
     d'abord ; un produit principal indisponible fait passer au suivant.
   - Ajout au panier via /cart/add.js : le volet « Adăugat în coș » s'ouvre seul.
   ========================================================= */
(function () {
  'use strict';
  var root = document.querySelector('[data-ev-quiz]');
  if (!root) return;

  var STORE = 'ev-quiz-state';
  var intro = root.querySelector('[data-evq-intro]');
  var app = root.querySelector('[data-evq-app]');
  var emailBox = root.querySelector('[data-evq-email]');
  var T = readJson(root.querySelector('[data-ev-quiz-texts]')) || {};
  var branches = [];
  var state = { screen: 'intro', branch: null, answers: [] };

  document.querySelectorAll('[data-ev-quiz-branch]').forEach(function (node) {
    var b = readJson(node);
    if (!b) return;
    b.code = b.code || b.id;
    b.questions = (b.questions || []).map(function (q) { return { title: q.title, answers: parseAnswers(q.answers) }; })
      .filter(function (q) { return q.title && q.answers.length; });
    b.results = (b.results || []).map(function (r, i) { r.index = i; r.codes = parseCodes(r.conditions); return r; });
    branches.push(b);
  });
  var visible = branches.filter(function (b) { return b.enabled !== false && b.label; });

  /* ---------- données ---------- */
  function readJson(node) { try { return JSON.parse(node.textContent); } catch (e) { return null; } }
  function slug(text) {
    return String(text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function parseAnswers(text) {
    return String(text || '').split(/\r?\n/).map(function (line) {
      var parts = line.split('|');
      var label = parts[0].trim();
      if (!label) return null;
      return { label: label, code: slug(parts[1] || label) };
    }).filter(Boolean);
  }
  function parseCodes(text) {
    return String(text || '').split(/[,;+]/).map(slug).filter(Boolean);
  }
  function branchByCode(code) {
    for (var i = 0; i < branches.length; i++) if (branches[i].code === code) return branches[i];
    return null;
  }
  function pick(branch, answers) {
    var chosen = {};
    answers.forEach(function (a) { chosen[a] = true; });
    var matches = branch.results.filter(function (r) {
      return r.codes.every(function (c) { return chosen[c]; });
    }).sort(function (a, b) { return b.codes.length - a.codes.length || a.index - b.index; });
    for (var i = 0; i < matches.length; i++) if (matches[i].product && matches[i].product.available) return matches[i];
    return null;
  }

  /* ---------- outils d'affichage ---------- */
  function esc(text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) return Shopify.formatMoney(cents, theme.moneyFormat);
    return new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100) + ' lei';
  }
  var photoMap;
  function photo(product, size) {
    if (photoMap === undefined) {
      var node = document.getElementById('ev-preview-photo-map');
      photoMap = node ? readJson(node) : null;
    }
    var p = photoMap && photoMap[product.handle] && photoMap[product.handle]['1'];
    if (p && p[size]) return p[size];
    return product.image || '';
  }
  function icon(name) {
    return '<svg class="ev-quiz__icon" aria-hidden="true" focusable="false"><use href="#evq-i-' + esc(name || 'frunza') + '"></use></svg>';
  }
  function firstVariant(product) {
    var list = product.variants || [];
    for (var i = 0; i < list.length; i++) if (list[i].id === product.variant && list[i].available) return list[i];
    for (var j = 0; j < list.length; j++) if (list[j].available) return list[j];
    return list[0] || { id: product.variant, price: 0, available: product.available };
  }
  function priceHtml(variant) {
    var html = '<span class="ev-quiz__price" data-evq-price>' + money(variant.price) + '</span>';
    if (variant.compare && variant.compare > variant.price) html += ' <s class="ev-quiz__compare">' + money(variant.compare) + '</s>';
    return html;
  }
  function sizeSelect(product, current) {
    var list = (product.variants || []).filter(function (v) { return v.available; });
    if (list.length < 2) return '';
    return '<label class="ev-quiz__size"><span>' + esc(T.size || 'Mărime') + '</span><select data-evq-variant>' +
      list.map(function (v) {
        return '<option value="' + v.id + '"' + (v.id === current.id ? ' selected' : '') + '>' + esc(v.title) + '</option>';
      }).join('') + '</select></label>';
  }
  function progress(n, total) {
    var label = String(T.step || 'Pasul {n} din {total}').replace('{n}', n).replace('{total}', total);
    return '<div class="ev-quiz__progress"><span class="ev-quiz__progress-label">' + esc(label) + '</span>' +
      '<div class="ev-quiz__track" role="progressbar" aria-valuemin="1" aria-valuemax="' + total + '" aria-valuenow="' + n + '" aria-label="' + esc(label) + '">' +
      '<div class="ev-quiz__bar" style="width:' + Math.round(n / total * 100) + '%"></div></div></div>';
  }
  function backButton() {
    return '<button type="button" class="ev-quiz__back" data-evq-back>‹ ' + esc(T.back || 'Înapoi') + '</button>';
  }

  /* ---------- écrans ---------- */
  function totalSteps(branch) {
    var max = 0;
    (branch ? [branch] : visible).forEach(function (b) { max = Math.max(max, b.questions.length); });
    return 1 + max;
  }
  function renderNeeds() {
    var html = '<div class="ev-quiz__head">' + backButton() + progress(1, totalSteps(null)) + '</div>' +
      '<h2 class="ev-quiz__question" tabindex="-1">' + esc(T.needsTitle) + '</h2>' +
      (T.needsText ? '<p class="ev-quiz__hint">' + esc(T.needsText) + '</p>' : '') +
      '<div class="ev-quiz__tiles">';
    visible.forEach(function (b) {
      html += '<button type="button" class="ev-quiz__tile" data-evq-branch="' + esc(b.code) + '">' + icon(b.icon) +
        '<span class="ev-quiz__tile-label">' + esc(b.label) + '</span>' +
        (b.hint ? '<span class="ev-quiz__tile-hint">' + esc(b.hint) + '</span>' : '') + '</button>';
    });
    return html + '</div>';
  }
  function renderQuestion(branch, index) {
    var q = branch.questions[index];
    var html = '<div class="ev-quiz__head">' + backButton() + progress(index + 2, totalSteps(branch)) + '</div>' +
      '<p class="ev-quiz__branch">' + icon(branch.icon) + esc(branch.label) + '</p>' +
      '<h2 class="ev-quiz__question" tabindex="-1">' + esc(q.title) + '</h2><div class="ev-quiz__answers">';
    q.answers.forEach(function (a) {
      var selected = state.answers[index] === a.code;
      html += '<button type="button" class="ev-quiz__answer' + (selected ? ' is-selected' : '') + '" data-evq-answer="' + esc(a.code) + '" aria-pressed="' + selected + '">' + esc(a.label) + '</button>';
    });
    return html + '</div>';
  }
  function productCard(product, main) {
    var v = firstVariant(product);
    var img = photo(product, main ? '600' : '360');
    var cls = main ? 'ev-quiz__product ev-quiz__product--main' : 'ev-quiz__product';
    return '<article class="' + cls + '" data-evq-product data-variant="' + v.id + '">' +
      '<a class="ev-quiz__product-media" href="' + esc(product.url) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(product.title) + '" loading="' + (main ? 'eager' : 'lazy') + '" width="600" height="600">' : '') + '</a>' +
      '<div class="ev-quiz__product-info">' +
        '<a class="ev-quiz__product-name" href="' + esc(product.url) + '">' + esc(product.title) + '</a>' +
        '<p class="ev-quiz__product-price">' + priceHtml(v) + '</p>' +
        sizeSelect(product, v) +
        '<div class="ev-quiz__product-actions">' +
          '<button type="button" class="ev-btn' + (main ? '' : ' ev-btn--outline') + ' ev-quiz__add" data-evq-add>' + esc(T.add || 'Adaugă în coș') + '</button>' +
          (main ? '<a class="ev-quiz__details" href="' + esc(product.url) + '">' + esc(T.details || 'Vezi detalii') + '</a>' : '') +
        '</div>' +
      '</div></article>';
  }
  function renderResult(branch) {
    var result = pick(branch, state.answers);
    var html = '<div class="ev-quiz__head">' + backButton() + '</div>';
    if (!result) {
      return html + '<h2 class="ev-quiz__question" tabindex="-1">' + esc(T.resultTitle) + '</h2>' +
        '<p class="ev-quiz__hint">' + esc(T.empty) + '</p>' +
        '<p><a class="ev-btn" href="' + esc(T.emptyLink || '/collections/all') + '">' + esc(T.emptyLinkLabel) + '</a></p>' +
        '<p><button type="button" class="ev-quiz__restart" data-evq-restart>' + esc(T.restart) + '</button></p>';
    }
    var extras = (result.complements || []).filter(function (p) { return p && p.available && p.handle !== result.product.handle; });
    html += '<div class="ev-quiz__result-head">' +
      (T.resultEyebrow ? '<span class="ev-eyebrow">' + esc(T.resultEyebrow) + '</span>' : '') +
      '<h2 class="ev-quiz__question" tabindex="-1">' + esc(result.title || T.resultTitle) + '</h2></div>' +
      productCard(result.product, true);
    if (result.why) {
      html += '<div class="ev-quiz__why"><p class="ev-quiz__why-title">' + esc(T.why) + '</p><p>' + esc(result.why).replace(/\n/g, '<br>') + '</p></div>';
    }
    if (extras.length) {
      html += '<div class="ev-quiz__extras"><p class="ev-quiz__extras-title">' + esc(T.complements) + '</p>' +
        extras.map(function (p) { return productCard(p, false); }).join('') + '</div>' +
        '<button type="button" class="ev-btn ev-btn--gold ev-quiz__add-all" data-evq-add-all>' + esc(T.addAll) + '</button>';
    }
    html += '<p class="ev-quiz__error" role="alert" data-evq-error></p>' +
      '<div data-evq-email-slot></div>' +
      '<p class="ev-quiz__restart-row"><button type="button" class="ev-quiz__restart" data-evq-restart>' + esc(T.restart) + '</button></p>';
    return html;
  }

  function render(focus) {
    var branch = branchByCode(state.branch);
    if (state.screen === 'intro' || !visible.length) {
      app.hidden = true; intro.hidden = false;
      if (emailBox) { emailBox.hidden = true; root.appendChild(emailBox); }
      return;
    }
    intro.hidden = true; app.hidden = false;
    if (emailBox) root.appendChild(emailBox);
    if (state.screen === 'needs' || !branch) app.innerHTML = renderNeeds();
    else if (state.screen === 'result') app.innerHTML = renderResult(branch);
    else app.innerHTML = renderQuestion(branch, state.screen);
    app.setAttribute('data-screen', typeof state.screen === 'number' ? 'question' : state.screen);
    var slot = app.querySelector('[data-evq-email-slot]');
    if (slot && emailBox) { slot.appendChild(emailBox); emailBox.hidden = false; }
    if (focus !== false) {
      var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
      if (window.pageYOffset > top) window.scrollTo(0, Math.max(0, top));
      var h = app.querySelector('.ev-quiz__question');
      if (h) h.focus({ preventScroll: true });
    }
  }
  var pushes = 0; // pas faits dans cette page : « Înapoi » = retour du navigateur
  function go(next, replace) {
    state = next;
    var copy = { screen: state.screen, branch: state.branch, answers: state.answers.slice() };
    try { history[replace ? 'replaceState' : 'pushState']({ evq: copy }, ''); if (!replace) pushes++; } catch (e) {}
    render();
  }
  function nextScreen(branch, index) {
    return index + 1 < branch.questions.length ? index + 1 : 'result';
  }
  function previous() {
    var branch = branchByCode(state.branch);
    if (state.screen === 'result' && branch && branch.questions.length) return { screen: branch.questions.length - 1, branch: branch.code, answers: state.answers };
    if (typeof state.screen === 'number' && state.screen > 0) return { screen: state.screen - 1, branch: state.branch, answers: state.answers };
    if (state.screen === 'needs') return { screen: 'intro', branch: null, answers: [] };
    return { screen: 'needs', branch: null, answers: [] };
  }

  /* ---------- panier ---------- */
  function addToCart(ids, button) {
    var label = button.textContent;
    var error = app.querySelector('[data-evq-error]');
    if (error) error.textContent = '';
    button.disabled = true;
    button.textContent = T.adding || 'Se adaugă…';
    window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1, properties: { '_Sursă': 'Quiz' } }; }) })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw d; });
      button.textContent = T.added || 'Adăugat în coș ✓';
      if (window.theme && theme.miniCart) { try { theme.miniCart.updateElements(); theme.miniCart.generateCart(); } catch (e) {} }
      setTimeout(function () { button.disabled = false; button.textContent = label; }, 2500);
    }).catch(function (d) {
      button.disabled = false;
      button.textContent = label;
      if (error) error.textContent = (d && d.description) || T.addError;
    });
  }

  /* ---------- événements ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t || !root.contains(t)) return;
    var branch = branchByCode(state.branch);
    if (t.hasAttribute('data-evq-start')) go({ screen: 'needs', branch: null, answers: [] });
    else if (t.hasAttribute('data-evq-branch')) {
      var b = branchByCode(t.getAttribute('data-evq-branch'));
      if (b) go({ screen: b.questions.length ? 0 : 'result', branch: b.code, answers: [] });
    } else if (t.hasAttribute('data-evq-answer') && branch) {
      var index = state.screen;
      var answers = state.answers.slice(0, index);
      answers[index] = t.getAttribute('data-evq-answer');
      go({ screen: nextScreen(branch, index), branch: branch.code, answers: answers });
    } else if (t.hasAttribute('data-evq-back')) {
      if (pushes > 0) history.back();
      else go(previous(), true);
    } else if (t.hasAttribute('data-evq-restart')) {
      go({ screen: 'needs', branch: null, answers: [] });
    } else if (t.hasAttribute('data-evq-add')) {
      addToCart([t.closest('[data-evq-product]').getAttribute('data-variant')], t);
    } else if (t.hasAttribute('data-evq-add-all')) {
      var ids = [];
      app.querySelectorAll('[data-evq-product]').forEach(function (card) { ids.push(card.getAttribute('data-variant')); });
      addToCart(ids, t);
    }
  });
  root.addEventListener('change', function (e) {
    var select = e.target.closest('[data-evq-variant]');
    if (!select) return;
    var card = select.closest('[data-evq-product]');
    var branch = branchByCode(state.branch);
    var result = branch && pick(branch, state.answers);
    if (!result) return;
    var products = [result.product].concat(result.complements || []);
    var id = Number(select.value);
    products.forEach(function (p) {
      (p && p.variants || []).forEach(function (v) {
        if (v.id === id) { card.setAttribute('data-variant', v.id); card.querySelector('[data-evq-price]').parentNode.innerHTML = priceHtml(v); }
      });
    });
  });
  window.addEventListener('popstate', function (e) {
    var s = e.state && e.state.evq;
    if (pushes > 0) pushes--;
    state = s ? { screen: s.screen, branch: s.branch, answers: s.answers || [] } : { screen: 'intro', branch: null, answers: [] };
    render();
  });

  /* ---------- formulaire email ---------- */
  if (emailBox) {
    var form = emailBox.querySelector('form');
    var tags = emailBox.querySelector('[data-evq-tags]');
    if (form) form.addEventListener('submit', function () {
      if (tags && state.branch) tags.value = 'newsletter,quiz,quiz-' + state.branch;
      try { sessionStorage.setItem(STORE, JSON.stringify({ branch: state.branch, answers: state.answers })); } catch (e) {}
    });
    var posted = /[?&]customer_posted=true/.test(location.search);
    var failed = emailBox.querySelector('[data-evq-email-error]');
    if (posted || failed) {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(STORE)); sessionStorage.removeItem(STORE); } catch (e) {}
      if (saved && branchByCode(saved.branch)) {
        if (posted && form) { form.hidden = true; emailBox.querySelector('[data-evq-email-success]').hidden = false; }
        state = { screen: 'result', branch: saved.branch, answers: saved.answers || [] };
        try { history.replaceState({ evq: state }, ''); } catch (e) {}
        render(false);
        emailBox.scrollIntoView({ block: 'center' });
        return;
      }
    }
  }

  /* ---------- avertissements dans l'éditeur Shopify ---------- */
  if (window.Shopify && Shopify.designMode) {
    var problems = [];
    branches.forEach(function (b) {
      var known = {};
      b.questions.forEach(function (q) { q.answers.forEach(function (a) { known[a.code] = true; }); });
      if (!b.results.some(function (r) { return !r.codes.length; })) problems.push(b.label + ': lipsește rezultatul implicit (fără condiții).');
      b.results.forEach(function (r, i) {
        if (!r.product) problems.push(b.label + ', rezultatul ' + (i + 1) + ': lipsește produsul principal.');
        r.codes.forEach(function (c) { if (!known[c]) problems.push(b.label + ', rezultatul ' + (i + 1) + ': codul „' + c + '” nu există în răspunsuri.'); });
      });
    });
    if (problems.length) {
      var box = document.createElement('div');
      box.className = 'ev-quiz-editor-note ev-quiz-editor-note--warn';
      box.innerHTML = '<strong>De verificat în quiz (vizibil doar în editor):</strong><ul>' + problems.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul>';
      root.insertBefore(box, root.firstChild);
    }
  }

  var initial = history.state && history.state.evq;
  if (initial && (initial.screen !== 'intro')) { state = initial; render(false); }
})();
